import React from "react";
import { Button, Modal } from "components";
import { useHistory } from "react-router-dom";
import { ToastWarning } from "../../../../../layouts/dashboard/sidebar/icons/icons/icons";


const ClosePage = ({ close, open, to, href }) => {

    const history = useHistory();

    return <Modal open={open} closeModal={close} overlayClassName="unsaved-overlay">
        <div className="modal-container">
            <div className="modal-icon error">
                <ToastWarning />
            </div>
            <div className="modal-header">Unsaved changes</div>
            <div className="modal-description">
                You have made some changes to the current page, if you close it they will be lost.
            </div>
            <div className="modal-footer">
                {to ?
                    <Button size="large" variant="warning" onClick={() => history.push(to)}>
                        Lose changes
                    </Button> :
                    <a href={href} className="w-50 h-100 d-flex align-items-center justify-content-center" style={{ color: "white" }}>
                        <Button size="large" className="w-100" variant="warning">
                            Lose changes
                        </Button>
                    </a>
                }
                <Button size="large" variant="secondary" onClick={close}>
                    Go Back
                </Button>
            </div>
        </div>
    </Modal>
}

export default ClosePage;
